/* global G */

import { isObj } from 'lib/util'
import { empty } from 'lib/util/object'

/**
 * Initializes the user settings by either setting the local adapter to the
 * incoming `settings` in case the user already has a userSettings
 * document or by creating a new document with calling the `create`
 * method.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {(function({detail?: {}}): Promise<void>)|*}
 */
const fn = app => async ({ detail = {} }) => {
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const adapter = app[G.ADAPTER][G.SETTINGS]
  const { [G.DATA]: { [G.API]: api = {}, settings = {} } = {} } = detail

  adapter[G.STATE][G.API] = api

  if (settings && isObj(settings) && !empty(settings)) {
    // User already has userSettings, lets use them
    adapter[G.API].change({ detail: { [G.DATA]: settings } })
  } else {
    // User doesn't have userSettings, lets create them
    await adapter[G.API].create()
  }

  eventBus.dispatch(eventBus.type(G.SETTINGS, G.DONE))
}

export default fn
